<template>
    <div class="tabel-wikkel">
        <table class="tabel">
            <thead>
                <tr>
                    <th>When</th>
                    <th>Team</th>
                    <th class="rechts">Players</th>
                    <th>Experience</th>
                    <th>Location</th>
                    <template v-if="past">
                        <th class="rechts">Played</th>
                        <th class="rechts">Score</th>
                        <th>Rating</th>
                    </template>
                    <th>Status</th>
                    <th>Booking</th>
                    <th><span hidden>Open</span></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="booking of bookings" :key="booking.id" class="klikbaar" @click="openBooking(booking, $event)">
                    <td class="nowrap">
                        <div v-if="sameDisplayedClock(booking.date, booking.location_time_zone, userTimeZone)" class="twee">
                            <span class="num"><span :class="flagClass(countryCodeForTimeZone(booking.location_time_zone))"></span>{{ timeAt(booking.date, booking.location_time_zone) }}</span>
                            <small>{{ dateAt(booking.date, booking.location_time_zone) }}</small>
                        </div>
                        <div v-else class="when-tz">
                            <div class="twee">
                                <span class="num"><span :class="flagClass(countryCodeForTimeZone(booking.location_time_zone))"></span>{{ timeAt(booking.date, booking.location_time_zone) }}</span>
                                <small>{{ dateAt(booking.date, booking.location_time_zone) }} · at location</small>
                            </div>
                            <div class="twee when-jouw">
                                <span class="num"><span :class="flagClass(countryCodeForTimeZone(userTimeZone))"></span>{{ timeAt(booking.date, userTimeZone) }}</span>
                                <small>{{ dateAt(booking.date, userTimeZone) }} · your time</small>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="twee afkap">
                            <span>{{ booking.team_name }}</span>
                            <small v-if="bookerName(booking)">{{ bookerName(booking) }}</small>
                        </div>
                    </td>
                    <td class="num rechts">{{ booking.player_count }}</td>
                    <td class="nowrap">{{ booking.experience_name }}</td>
                    <td>
                        <div class="twee">
                            <span class="nowrap">{{ booking.location_name }}</span>
                            <small>{{ booking.xcube_name }} {{ booking.xcube_letter }} · {{ (booking.language || "").toUpperCase() }}</small>
                        </div>
                    </td>
                    <template v-if="past">
                        <td class="num rechts">{{ booking.minutes_played ? `${booking.minutes_played} min` : "–" }}</td>
                        <td class="num rechts">{{ booking.score ? formatNumber(booking.score) : "–" }}</td>
                        <td>
                            <span class="rating">
                                <template v-if="booking.rating || booking.rating_location">
                                    <span v-if="booking.rating" title="Game rating">
                                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 6.3 6.9 1-5 4.9 1.2 6.8L12 18l-6.1 3 1.2-6.8-5-4.9 6.9-1z" /></svg>{{ booking.rating }}
                                    </span>
                                    <span v-if="booking.rating_location" title="Location rating">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 21V5l8-3 8 3v16M9 21v-5h6v5" /></svg>{{ booking.rating_location }}
                                    </span>
                                </template>
                                <span v-else class="geen">No rating</span>
                            </span>
                        </td>
                    </template>
                    <td>
                        <span class="badge" :class="getBookingStatus(booking).cls">{{ getBookingStatus(booking).label }}</span>
                    </td>
                    <td>
                        <span class="bron"><span class="tag">{{ bookingSourceTag(booking.code) }}</span>{{ bookingShortCode(booking.code) }}</span>
                    </td>
                    <td class="rechts">
                        <router-link class="btn btn-stil btn-sm" :to="{ name: 'view-booking', params: { id: booking.id, booking } }" @click.native.stop>View</router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { defineProps } from "vue";
import { useRouter } from "vue-router/composables";
import { countryCodeForTimeZone, sameDisplayedClock } from "../../helpers/dates";
import { getBookingStatus } from "../../helpers/bookingStatus";
import { bookingShortCode, bookingSourceTag } from "../../helpers/bookingSource";

dayjs.extend(utc);
dayjs.extend(timezone);

defineProps({
    bookings: {
        type: Array,
        default: () => [],
    },
    past: {
        type: Boolean,
        default: false,
    },
});

const router = useRouter();

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const formatNumber = (n) => new Intl.NumberFormat("nl-NL").format(n);

const timeAt = (date, tz) => dayjs(date).tz(tz).format("HH:mm");
const dateAt = (date, tz) => dayjs(date).tz(tz).format("ddd D MMM");

const flagClass = (country) => (country ? `vlag fi fi-${country.toLowerCase()}` : "");

const bookerName = (booking) => [booking.first_name, booking.last_name].filter(Boolean).join(" ").trim();


const openBooking = (booking, event) => {
    if (event.target.closest("a")) {
        return;
    }
    router.push({ name: "view-booking", params: { id: booking.id, booking } });
};
</script>
